import {getInitialState} from '@oegbv/ui-shared'
import {InitialState} from '../types/InitialState'

// const LOCAL_KIARA_URL = 'https://oegbv-kiara-placeholder.vercel.app'
const LOCAL_KIARA_URL = 'https://kiara-demo.oegbverlag.at/iframe'

export const getKiaraUrl = (): string => (getInitialState() as unknown as InitialState).kiaraUrl ?? LOCAL_KIARA_URL
